import React from 'react'
import { graphql } from 'gatsby';
import Layout from './layout'
import PageBanner from '../modules/page-banner'
import Seo from 'gatsby-plugin-wpgraphql-seo';

const PageTemplate = ({ data: { page } }) => {
  
  if (!page) { return null }
  return (
    <Layout>
      <Seo post={page} />
      <div className="DefaultPage">
       <PageBanner title={page.title} image={page.featuredImage?.node} />

        <div className="Container">
          {page.content && (
            <div
              className="DefaultPage__content WysiwygContent"
              dangerouslySetInnerHTML={{__html: page.content}}
            />
          )}
        </div>
      </div>
    </Layout>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query currentPageQuery($id: String) {
    page: wpPage(id: { eq: $id }, template: {templateName: {eq: "Default"}}) {
      title
      content
      featuredImage {
        node {
          localFile {
            childCloudinaryAsset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          mediaDetails {
            file
          }
        }
      }
      nodeType
      uri
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
  }
`